import Identity from "./Identity.model";
import Patient from "./Patient.model";

export default class Incident {
    constructor() {
        this.id;
        this.providerId;
        this.sapsCasNumber;
        this.driverIdentityId;
        this.sapdMetroId;
        this.vehicleType;
        this.vehicleRegistrationNumber;
        this.dateOf;
        this.addressLine1;
        this.addressLine2;
        this.addressLine3;
        this.city;
        this.province;
        this.postalCode;
        this.country;
        this.driverLicenseFileId;
        this.accidentReportFileId;
        this.incidentReportFileId;
        this.isDeleted;
        this.createdByIdentityId;
        this.createdAt;
        this.modifiedAt;
        this.driverLicenseAvailable;
        this.accidentReportAvailable;
        this.incidentReportAvailable;
        this.driverIdentity;
        this.createdByIdentity;
        this.isLateRegistrationApproved;
        this.patients = [];
        this.accidentReportNumber;
        this.note;
        this.notes;
        this.isArRegistered;
        this.isSuspended
        this.isFraudulent;
        this.isFinalised;

        this.notArRegisteredNote;
        this.notArUploadedNote;

        //this.isLateRegistrationSuspended;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.providerId = setEntity.providerId;
        this.sapsCasNumber = setEntity.sapsCasNumber;
        this.driverIdentityId = setEntity.driverIdentityId;
        this.sapdMetroId = setEntity.sapdMetroId;
        this.vehicleType = setEntity.vehicleType;
        this.vehicleRegistrationNumber = setEntity.vehicleRegistrationNumber;
        this.dateOf = setEntity.dateOf;
        this.addressLine1 = setEntity.addressLine1;
        this.addressLine2 = setEntity.addressLine2;
        this.addressLine3 = setEntity.addressLine3;
        this.city = setEntity.city;
        this.province = setEntity.province;
        this.postalCode = setEntity.postalCode;
        this.country = setEntity.country;
        this.driverLicenseFileId = setEntity.driverLicenseFileId;
        this.accidentReportFileId = setEntity.accidentReportFileId;
        this.incidentReportFileId = setEntity.incidentReportFileId;
        this.isDeleted = setEntity.isDeleted;
        this.createdByIdentityId = setEntity.createdByIdentityId;
        this.createdAt = setEntity.createdAt;
        this.modifiedAt = setEntity.modifiedAt;
        this.driverLicenseAvailable = setEntity.driverLicenseAvailable;
        this.accidentReportAvailable = setEntity.accidentReportAvailable;
        this.incidentReportAvailable = setEntity.incidentReportAvailable;
        this.driverIdentity = setEntity.driverIdentity ? new Identity().set(setEntity.driverIdentity) : new Identity();
        this.createdByIdentity = setEntity.createdByIdentity;
        this.isLateRegistrationApproved = setEntity.isLateRegistrationApproved;
        this.patients = [];
        if (setEntity.patients)
            setEntity.patients.forEach((patient) => {
                this.patients.push(new Patient().set(patient));
            });
        this.accidentReportNumber = setEntity.accidentReportNumber;
        this.note = setEntity.note;

        this.notes = [];
        if (setEntity.notes)
            setEntity.notes.forEach((note) => {
                this.notes.push(note);
            });

        this.isArRegistered = setEntity.isArRegistered;
        this.isSuspended = setEntity.isSuspended;
        this.isFraudulent = setEntity.isFraudulent;
        this.isFinalised = setEntity.isFinalised;

        //this.isLateRegistrationSuspended = setEntity.isLateRegistrationSuspended;

        return this;
    }
}
